import { render } from "./Pesquisa.vue?vue&type=template&id=3c02c46e"
import script from "./Pesquisa.vue?vue&type=script&lang=js"
export * from "./Pesquisa.vue?vue&type=script&lang=js"

import "./Pesquisa.vue?vue&type=style&index=0&id=3c02c46e&lang=css"
script.render = render

export default script